// year-wrapped 纯 SVG 渲染。复用 tick.wrappedStat 推导当前 stat + 动画阶段。
import type { SceneData } from '../../api/types'
import type { WrappedData } from './types'
import { wrappedStat } from './tick'
import { COLORS, FONT_SANS, FONT_MONO, esc } from '../../export/svgRender'

export function render(data: SceneData, time: number): string {
  const d = data as unknown as WrappedData
  const { currentStat, animPhase } = wrappedStat(data, time)
  const stats = d.stats || []
  const stat = stats[currentStat]

  if (!stat) {
    return `
  <text x="540" y="960" font-size="56" font-weight="700" fill="${COLORS.t3}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">See you next year! 🎉</text>`
  }

  const grad = `<defs><linearGradient id="wbg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${stat.color}" stop-opacity="0.15"/><stop offset="1" stop-color="${stat.color}" stop-opacity="0.05"/></linearGradient></defs>
  <rect x="0" y="0" width="1080" height="1920" fill="url(#wbg)"/>`

  // animPhase 近似：enter/exit 半透明（淡入淡出），hold 全显
  const opacity = animPhase === 'hold' ? 1 : 0.45

  return `${grad}
  <g opacity="${opacity}">
  <text x="540" y="460" font-size="36" font-weight="700" fill="${COLORS.t3}" text-anchor="middle" dominant-baseline="middle" letter-spacing="14" font-family="${FONT_MONO}">${esc(d.year)}</text>
  <text x="540" y="780" font-size="180" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(stat.emoji)}</text>
  <text x="540" y="1140" font-size="170" font-weight="800" fill="${COLORS.w}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_MONO}">${esc(stat.value)}</text>
  <text x="540" y="1340" font-size="48" font-weight="500" fill="${COLORS.t2}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(stat.label)}</text>
  <text x="540" y="1480" font-size="28" font-weight="400" fill="${COLORS.t4}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_MONO}">${currentStat + 1} / ${stats.length}</text>
  </g>`
}
